import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { clearTesterUnlock } from '../../helpers/testerAccess';
import { clearAuth, logoutUser } from '../../store/actions/authActions';
import { clearSubscription } from '../../store/actions/subscriptionActions';

/**
 * Clears session when ?resetAccess=1 ΓÇö shows Login page again.
 */
const FlowResetHandler = ({ logoutUserAction, clearAuthAction, clearSubscriptionAction }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const hash = window.location.hash || '';
    const wantsReset =
      params.get('resetAccess') === '1'
      || hash.includes('resetAccess=1')
      || (window.location.search || '').includes('resetAccess=1');

    if (!wantsReset) return;

    clearTesterUnlock();
    logoutUserAction().finally(() => {
      clearAuthAction();
      clearSubscriptionAction();
      if (!location.pathname.startsWith('/login')) {
        history.replace('/login');
      } else {
        history.replace('/login');
      }
    });
  }, [location.pathname, location.search, history, logoutUserAction, clearAuthAction, clearSubscriptionAction]);

  return null;
};

export default connect(null, {
  logoutUserAction: logoutUser,
  clearAuthAction: clearAuth,
  clearSubscriptionAction: clearSubscription,
})(FlowResetHandler);
